<template>
	<div class="home">
		<div class="content">
			<div v-if="!loading">
				<NavBar :nav="false" />
				<div class="item">
					<div class="left">申请人</div>
					<div class="rig">{{ datails.name }}</div>
				</div>
				<div class="item">
					<div class="left">公司</div>
					<div class="rig">{{ datails.company }}</div>
				</div>
				<div class="item">
					<div class="left">职位</div>
					<div class="rig">{{ datails.position }}</div>
				</div>
				<div class="item">
					<div class="left">邮箱</div>
					<div class="rig">{{ datails.plaintext_data.email }}</div>
				</div>
				<div class="item">
					<div class="left">手机号</div>
					<div class="rig">{{ datails.plaintext_data.phone }}</div>
				</div>
				<div class="item">
					<div class="left" style="min-width: 16vh">您关注的3D打印材料</div>
					<div class="rig" style="width: 84vh">{{ datails.follow + '' }}</div>
				</div>
				<div class="item">
					<div class="left" style="min-width: 16vh">您所处的行业</div>
					<div class="rig" style="width: 84vh">{{ datails.follow1 + '' }}</div>
				</div>
				<div class="item">
					<div class="left" style="min-width: 16vh">您关注的应用领域</div>
					<div class="rig" style="width: 84vh">{{ datails.follow2 + '' }}</div>
				</div>
				<div class="item">
					<div class="left">设备类型</div>
					<div class="rig">{{ datails?.project?.type }}</div>
				</div>
				<div class="item">
					<div class="left">样品用途</div>
					<div class="rig">{{ datails?.usage }}</div>
				</div>
				<div class="item">
					<div class="left">性能要求</div>
					<div class="rig">{{ datails?.performance }}</div>
				</div>
				<div class="item">
					<div class="left">除样条外，您的其他样品需求是什么？请详细描述。</div>
					<div class="rig">&nbsp;</div>
				</div>
				<div class="item">
					<div class="left">&nbsp;</div>
					<div class="rig">{{ datails?.project?.info }}</div>
				</div>
				<div class="item">
					<div class="left">邮寄地址</div>
					<div class="rig">{{ datails?.delivery?.address }}</div>
				</div>
				<div class="item">
					<div class="left">邮编</div>
					<div class="rig">{{ datails?.delivery?.zipcode || `-` }}</div>
				</div>
				<div class="item" v-if="datails?.drug?.typedata?.name">
					<div class="left">样品分类</div>
					<div class="rig">{{ datails?.drug?.typedata?.name }}</div>
				</div>
				<div class="item">
					<div class="left">样品名称</div>
					<div class="rig">{{ datails?.drug?.name || datails?.drug_name }}</div>
				</div>
				<div class="item">
					<div class="left">申请状态</div>
					<div class="rig">{{ stateList[datails?.state] }}</div>
				</div>
				<div class="item" v-if="datails?.state == 1 || datails?.state == 3">
					<div class="left">快递单号</div>
					<div class="rig">{{ datails?.delivery?.express_no || '-' }}</div>
				</div>
				<div class="item" v-if="datails?.state == 4">
					<div class="left">不发货原因</div>
					<div class="rig">{{ datails.reason || '-' }}</div>
				</div>
				<!-- 发货人1销售跟进,2赢创发货,3经销商昌为发货,4经销商风泓发货 -->
				<div class="item" v-if="datails?.state != 2">
					<div class="left" style="min-width: 10vh">发货类型</div>
					<!-- <div class="rig">{{expressList[datails.express_user-1]}}</div> -->

					<template v-if="!datails?.express_type && datails?.saleinfo && datails?.express_user">
						<div class="rig" v-if="datails?.saleinfo?.user_type == 1">您的申请已收到，我们将安排销售跟进</div>
						<div class="rig" v-if="datails?.saleinfo?.user_type == 2" v-html="datails?.saleinfo?.send_descript || `暂无信息`"></div>
					</template>
					<template v-else-if="datails?.express_type && !datails?.express_user">
						<div class="rig" v-if="datails?.express_type == 1">赢创发货-两周内</div>
						<div class="rig" v-if="datails?.express_type == 2">赢创发货-1个月内</div>
						<div class="rig" v-if="datails?.express_type == 3">赢创发货-2个月内</div>
					</template>
					<div class="rig" v-else>暂无信息</div>

					<!-- <div class="rig" v-if="datails.express_type == 0">-</div>
					<div class="rig" v-if="datails.express_user == 1">您的申请已收到，我们将安排销售跟进</div>
					<div class="rig" v-if="datails.express_user == 2">赢创发货-两周内</div>
					<div class="rig" v-if="datails.express_user == 3">
						您的申请已批准
						<br />
						样品会由经销商上海昌为医药辅料技术有限公司于2周内寄出，
						<br />
						昌为联系方式：倪樱Nicco
						<br />
						138 1818 0301
						<br />
						Sample@chineway.com.cn
					</div>
					<div class="rig" v-if="datails.express_user == 4">
						您的申请已批准
						<br />
						样品会由经销商上海风泓药用辅料技术有限公司于2周内寄出，
						<br />
						风泓联系方式：刘经理
						<br />
						400-021-0228
						<br />
						liuy@fenghongpharm.com
					</div> -->
				</div>
				<div class="item">
					<div class="left" style="min-width: 10vh">审批意见</div>
					<div class="rig">{{ datails.approve || '-' }}</div>
				</div>
				<div class="item">
					<div class="left">审批时间</div>
					<div class="rig">{{ datails.approve_time || '-' }}</div>
				</div>
				<div class="item" v-if="(datails?.state == 1 || datails?.state == 3 || datails?.state == 4) && datails.express_user == 2">
					<div class="left">操作时间</div>
					<div class="rig">{{ datails?.delivery?.express_time || '-' }}</div>
				</div>
			</div>

			<div v-else class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div>
			<float-btn :showApply="true"></float-btn>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import floatBtn from '@/components/FloatBtn.vue';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '@/config/config';
import NavBar from '@/components/NavBar.vue';
export default {
	components: {
		floatBtn,
		NavBar
	},
	data() {
		return {
			datails: {},
			loading: true,
			stateList: ['未审批', '已通过', '不通过', '已发货', '不发货'], //0未审批，1已通过，2不通过，3已发货，4不发货
			expressList: ['销售跟进', '赢创发货', '经销商昌为发货', '经销商风泓发货'] //1销售跟进,2赢创发货,3经销商昌为发货,4经销商风泓发货
		};
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({ page_title: '样品申请记录详情' });
		this.initShare();
		this.getDetails();
	},
	methods: {
		getDetails() {
			this.loading = true;
			this.$http.get(`/api/platform/sampledrug/applylog/${this.$route.query?.id}`).then((res) => {
				// console.log('res', res.data);
				this.datails = res.data;
				this.loading = false;
			});
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	width: 100%;
	padding: 30px 27px;
	display: block;
	background: rgba(249, 247, 243, 0.66);

	.content {
		width: 100%;
		background: rgba(255, 255, 255, 0.6);
		box-shadow: 0px -9px 65px 0px rgba(0, 0, 0, 0.13);
		padding: 30px;

		.item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-bottom: 45px;

			.left {
				min-width: 100px;
				font-size: 30px;
				font-weight: normal;
				color: #666666;
			}

			.rig {
				font-size: 30px;
				font-weight: normal;
				color: #000000;
				text-align: right;
				word-break: break-all;
			}
		}

		.item:nth-last-of-type(1) {
			margin-bottom: 0;
		}
	}
}
</style>
